<ng-container *ngIf="dataLoading && items.length == 0">
    <div class="content-centered-column">
        <div class="content-centered-row">
            <ion-spinner></ion-spinner>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="user && (!dataLoading || items.length)">
    <div class="header">
        <ion-row *ngIf="plt.sizeSm"
                 class="ion-no-padding ion-align-items-center">

            <ion-col>
                <ion-select *ngIf="event.marketplaces.length > 1"
                            [interface]="selectType"
                            [interfaceOptions]="{cssClass:'not-overflow'}"
                            [cancelText]="'BUTTON_CANCEL' |  translate"
                            name="marketplace"
                            id="marketplace"
                            #category_id="ngModel"
                            [(ngModel)]="marketplace"
                            (ionChange)="applyFilter(0, true, true)">
                    <ion-select-option *ngFor="let marketplace of event.marketplaces"
                                       [value]="marketplace">
                        {{ marketplace.translate(userLang, event.default_locale).name }}
                    </ion-select-option>
                </ion-select>
                <h2 *ngIf="event.marketplaces.length == 1">
                    <img class="logo"
                    width="32"
                    height="32"
                    img-logo
                    [src]="user.selected_participant?.event.logo_url">
                    {{ marketplace.translate(userLang, event.default_locale).name }}
                </h2>
            </ion-col>
            <ion-col *ngIf="marketplace.description"
                     size="2"
                     class="ion-text-center">
                <svg-icon [applyClass]="true"
                          src="/assets/icons/information-circle-outline.svg"
                          class="fill-primary"
                          (click)="openInfo()">
                </svg-icon>
            </ion-col>
        </ion-row>

        <ion-row class="ion-no-padding search-header">
            <ion-col size="10"
                     [attr.size-md]="(!plt.sizeSm
                                         && user.selected_participant
                                         && marketplace.post_allowed
                                         && !user.selected_participant.invisible) ? 5 : 8">

                <div class="search-box">
                    <ion-searchbar [(ngModel)]="search"
                                   (ionChange)="applyFilter(categoryId)"
                                   [placeholder]="'MARKETPLACE_POST_LIST_SEARCH_PLACEHOLDER' | translate">
                    </ion-searchbar>

                    <ion-select [interface]="selectType"
                                [interfaceOptions]="{cssClass:'not-overflow'}"
                                [cancelText]="'BUTTON_CANCEL' |  translate"
                                name="category"
                                id="category"
                                #category_id="ngModel"
                                [(ngModel)]="categoryId"
                                (ionChange)="applyFilter(categoryId)">
                        <ion-select-option [value]="0">
                            {{ 'MARKETPLACE_CATEGORY_ALL' | translate }}
                        </ion-select-option>
                        <ion-select-option *ngFor="let category of marketplace.categories"
                                           [value]="category.id">
                            {{ category.translate(userLang, event.default_locale).name }}
                        </ion-select-option>
                        <ion-select-option *ngIf="marketplace.post_allowed"
                                           [value]="-1">
                            {{ 'MARKETPLACE_CATEGORY_MY_POST' | translate }}
                        </ion-select-option>
                    </ion-select>
                </div>
            </ion-col>
            <ion-col *ngIf="plt.sizeSm"
                     size="2">
                <ion-badge *ngIf="filterKeywords && filterKeywords.length > 0">
                    {{ filterKeywords.length }}
                </ion-badge>
                <ion-button color="secondary"
                            (click)="showKeywordsModal()">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/filter-outline.svg"
                              class="fill-menu-contrast">
                    </svg-icon>
                </ion-button>
            </ion-col>
            <ion-col *ngIf="!plt.sizeSm
                                && user.selected_participant
                                && marketplace.post_allowed
                                && !user.selected_participant.invisible"
                     size="12"
                     size-md="3"
                     class="ion-text-right">
                <ion-button (click)="createMarketplacePost()">
                    {{ 'MARKETPLACE_POST_CREATE' | translate }}
                </ion-button>
            </ion-col>
            <ion-col *ngIf="!plt.sizeSm"
                     size="12"
                     size-md="4">
                <ion-select *ngIf="event.marketplaces.length > 1"
                            [interface]="selectType"
                            [interfaceOptions]="{cssClass:'not-overflow'}"
                            [cancelText]="'BUTTON_CANCEL' |  translate"
                            name="marketplace"
                            id="marketplace"
                            #category_id="ngModel"
                            [(ngModel)]="marketplace"
                            (ionChange)="applyFilter(0, true, true)">
                    <ion-select-option *ngFor="let marketplace of event.marketplaces"
                                       [value]="marketplace">
                        {{ marketplace.translate(userLang, event.default_locale).name }}
                    </ion-select-option>
                </ion-select>
                <h2 *ngIf="event.marketplaces.length == 1">
                    {{ marketplace.translate(userLang, event.default_locale).name }}
                </h2>
            </ion-col>
        </ion-row>
    </div>

    <ion-row class="ion-no-padding">
        <ion-col size="12"
                 size-md=8
                 class="ion-no-padding list">

            <ng-container *ngIf="plt.sizeSm">
                <div class="scroll-box"
                     infiniteScroll
                     [infiniteScrollDisabled]="loadingInfinite"
                     [infiniteScrollDistance]="2"
                     [infiniteScrollUpDistance]="2.5"
                     [infiniteScrollThrottle]="150"
                     [scrollWindow]="false"
                     [alwaysCallback]="true"
                     (scrolled)="loadData()">
                    <ng-container *ngFor="let item of items; let c = index">

                        <marketplace-detail *ngIf="item.id != editId"
                                            [marketplacePost]="item"
                                            [event]="event"
                                            [user]="user"
                                            [marketplace]="marketplace"
                                            [defaultLocale]="event.default_locale"
                                            (onDelete)="marketplaceDeleted($event)">
                        </marketplace-detail>

                    </ng-container>
                </div>

            </ng-container>

            <ng-container *ngIf="!plt.sizeSm">

                <ng-container *ngFor="let item of items; let c = index">

                    <marketplace-detail *ngIf="item.id != editId"
                                        [marketplacePost]="item"
                                        [event]="event"
                                        [user]="user"
                                        [marketplace]="marketplace"
                                        [defaultLocale]="event.default_locale"
                                        (onDelete)="marketplaceDeleted($event)">
                    </marketplace-detail>

                </ng-container>

                <ion-infinite-scroll *ngIf="!detail"
                                     threshold="100px"
                                     (ionInfinite)="loadData($event)">
                    <ion-infinite-scroll-content loadingSpinner="bubbles"
                                                 [loadingText]="'MARKETPLACE_POST_LIST_LOADING_MORE' | translate">
                    </ion-infinite-scroll-content>
                </ion-infinite-scroll>
            </ng-container>
        </ion-col>
        <ion-col *ngIf="!plt.sizeSm">
            <ion-card *ngIf="marketplace.description"
                      [innerHTML]="marketplace.description">
            </ion-card>
            <marketplace-keywords #keywords
                                  [marketplace]="marketplace"
                                  [pivots]="filterKeywords"
                                  [favoriteSaving]="true"
                                  [allowKeywordSuggest]="false"
                                  (onKeywordChanged)="applyKeywords($event)">
            </marketplace-keywords>
        </ion-col>
    </ion-row>
</ng-container>